/** Opciones habituales del selector, en el orden en que se muestran. */
export const MEAL_OPTIONS = ['breakfast', 'lunch', 'dinner', 'snack'];
/**
 * Clave antigua, compartida por todas las cuentas del dispositivo. Ya no se
 * escribe: la preferencia va por cuenta ({@link lastMealKey}).
 */
export const LAST_MEAL_KEY = 'fitness.food.lastMeal';
/** Clave de la última comida elegida por una cuenta: cada cuenta tiene la suya. */
export function lastMealKey(userId) {
    return `${LAST_MEAL_KEY}.${userId}`;
}
function isMeal(value) {
    return value === 'other' || MEAL_OPTIONS.some((meal) => meal === value);
}
/**
 * Sin reloj ni almacenamiento implícitos: la fecha y la hora son locales.
 * `other` se conserva para los enlaces de versiones anteriores.
 */
export function defaultMeal({ date, now, queryMeal, lastMeal, }) {
    if (isMeal(queryMeal))
        return queryMeal;
    const today = [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0'),
    ].join('-');
    if (date !== today)
        return isMeal(lastMeal) ? lastMeal : 'lunch';
    const minutes = now.getHours() * 60 + now.getMinutes();
    if (minutes < 11 * 60 + 30)
        return 'breakfast';
    if (minutes < 16 * 60 + 30)
        return 'lunch';
    if (minutes < 20 * 60)
        return 'snack';
    return 'dinner';
}
//# sourceMappingURL=defaultMeal.js.map